export default __webpack_public_path__ + "e21cec964bd0b3c93f455c166255254b.png";